export enum Z_INDEX {
  Background = 1,
  VesselNav,
  InputList,
  MainNav,
  MainNavUserMenu,
  Modal = 1401,
  Popup,
  Tour,
}
